import { render } from "./RegionAkmola.vue?vue&type=template&id=aa1f7b28&ts=true"
import script from "./RegionAkmola.vue?vue&type=script&lang=ts"
export * from "./RegionAkmola.vue?vue&type=script&lang=ts"

import "./RegionAkmola.vue?vue&type=style&index=0&id=aa1f7b28&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__